import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { jsx } from 'react/jsx-runtime';

var Label = React.forwardRef(function Label2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    LabelPrimitive.Root,
    {
      ref,
      className: cn(
        "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        className
      ),
      ...props
    }
  );
});

export { Label };
//# sourceMappingURL=chunk-676CI6I4.js.map
//# sourceMappingURL=chunk-676CI6I4.js.map